import React from 'react';

/**
 * A confirmation modal with Yes/No buttons.
 */
export default function ConfirmationModal({ message, onConfirm, onCancel }) {
  if (!message) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
      <div className="bg-white p-4 rounded shadow max-w-sm w-full">
        <p className="mb-4">{message}</p>
        <div className="flex justify-end space-x-2">
          <button onClick={onCancel} className="px-3 py-1 bg-gray-300 text-black rounded">
            Tidak
          </button>
          <button onClick={onConfirm} className="px-3 py-1 bg-red-500 text-white rounded">
            Ya
          </button>
        </div>
      </div>
    </div>
  );
}
